import React, { useState } from 'react';
import SearchableDropdown, {
  DropdownItem
} from '../../../SearchableDropdown/SearchableDropdown';
import IntentSlot from '../../../../types/BotBuilder/IntentSlot';
import Slot from '../../../../types/BotBuilder/Slot';
import { SystemVariableDto } from '../../../../services/SystemVariableService/SystemVariableService';
import useVariableDropdownLogic from '../../../../hooks/useVariableDropdownLogic';

interface VariableDropdownProps {
  intentSlots?: IntentSlot[];
  globalSlots?: Slot[];
  systemVariables: SystemVariableDto[];
  onSelect: (varName: string, isSystem: boolean, isGlobal?: boolean) => void;
  triggerClassName?: string;
  placeholder?: string;
  triggerIcon?: React.ReactNode;
  title?: string;
}

function VariableDropdown({
  intentSlots = [],
  globalSlots = [],
  systemVariables,
  onSelect,
  triggerClassName = '',
  placeholder = 'Insert variable...',
  triggerIcon,
  title
}: Readonly<VariableDropdownProps>): React.ReactElement {
  const [selectedItem, setSelectedItem] = useState<DropdownItem | null>(null);

  const {
    filteredItems,
    handleSearch,
    handleSelect: handleVariableSelect
  } = useVariableDropdownLogic({
    intentSlots,
    globalSlots,
    systemVariables,
    onSelect
  });

  const handleSelect = (item: DropdownItem): void => {
    handleVariableSelect(item);
    setSelectedItem(null);
  };

  const handleClear = (): void => {
    setSelectedItem(null);
  };

  return (
    <SearchableDropdown
      items={filteredItems}
      selectedItem={selectedItem}
      onSelect={handleSelect}
      onSearch={handleSearch}
      onClear={handleClear}
      placeholder={triggerIcon ? '' : placeholder}
      searchPlaceholder='Search variables...'
      showClearButton={false}
      className=''
      triggerClassName={triggerClassName}
      emptyText='No variables available'
      triggerIcon={triggerIcon}
      title={title}
    />
  );
}

export default VariableDropdown;
